import { render, staticRenderFns } from "./Contatos.vue?vue&type=template&id=55a15426"
import script from "./Contatos.vue?vue&type=script&lang=js"
export * from "./Contatos.vue?vue&type=script&lang=js"
import style0 from "./Contatos.vue?vue&type=style&index=0&id=55a15426&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports